<ion-app>
  <div class="progress-bar" [ngClass]="{visible: (loadingService.isVisibleSubj() | async)}">
    <ion-progress-bar type="indeterminate"></ion-progress-bar>
  </div>
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay">
      <ion-header>
        <ion-toolbar color="light">
          <ion-title class="menu-header">
            <img src="assets/imgs/logo.png" class="logo-image" alt="{{ 'Safe Check-in' | translate }}" />
            <span>{{ 'Safe Check-in' | translate }}</span>
          </ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list id="inbox-list" *ngIf="menuLoaded">
          <ion-menu-toggle
            auto-hide="false" *ngFor="let p of appPages; let i = index">
            <ion-item *ngIf="p.enabled()" routerDirection="root"
                      [routerLink]="[p.url]" lines="none"
                      detail="false" [class.selected]="p.selected()">
              <ion-icon slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-outline'"></ion-icon>
              <ion-label>{{ p.title | translate }}</ion-label>
              <ion-badge *ngIf="p.count && p.count() > 0" slot="end">{{p.count()}}</ion-badge>
            </ion-item>
          </ion-menu-toggle>
          <ion-item *ngIf="userData?.role === 'admin'" (click)='openLocationAdmin()' class='admin-link' lines="none" detail="false" >
            <ion-icon slot="start" name="laptop-outline"></ion-icon>
            <ion-icon slot="end" style="opacity: 0.2" name="arrow-redo-outline"></ion-icon>
            <ion-label>{{ 'Location Admin' | translate }}</ion-label>
          </ion-item>

          <ion-item *ngIf="instantLogin && isAndroid" (click)='displayShortcutAppAlert()' lines="none" detail="false" >
            <ion-icon slot="start" name="phone-portrait-outline"></ion-icon>
            <ion-icon slot="end" style="opacity: 0.2" name="arrow-redo-outline"></ion-icon>
            <ion-label>{{ 'Add Safe Check-In to the home screen' | translate }}</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
